module.exports = flarum.core.compat['models/forum'];